import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { CheckCircle, XCircle, Warning } from '@phosphor-icons/react';

export default function SystemHealthPage() {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/health').then(r => { setHealth(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64 text-gray-400">Checking system health...</div>;
  if (!health) return <div className="text-red-500">Failed to load health data</div>;

  const StatusIcon = ({ ok }) => ok ? <CheckCircle size={18} className="text-emerald-600" weight="fill" /> : <XCircle size={18} className="text-red-600" weight="fill" />;

  return (
    <div data-testid="system-health-page">
      <div className="mb-6">
        <h1 className="font-heading text-3xl font-bold tracking-tighter text-gray-900">System Health</h1>
        <p className="text-sm text-gray-500 mt-1">
          Status: <span className={`font-mono font-medium ${health.status === 'healthy' ? 'text-emerald-700' : 'text-amber-700'}`}>{health.status}</span>
        </p>
      </div>

      {/* Checks */}
      <div className="border border-gray-200 rounded-md bg-white p-6 mb-6">
        <h3 className="text-xs font-mono uppercase tracking-wider text-gray-500 mb-4">Service Checks</h3>
        <div className="space-y-3">
          {Object.entries(health.checks || {}).map(([key, check]) => (
            <div key={key} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0">
              <div className="flex items-center gap-3">
                <StatusIcon ok={check.ok} />
                <span className="text-sm text-gray-900 font-medium">{key.replace(/_/g, ' ')}</span>
              </div>
              <span className={`text-xs font-mono ${check.ok ? 'text-emerald-600' : 'text-red-600'}`}>{check.status}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Collections */}
      <div className="border border-gray-200 rounded-md bg-white p-6">
        <h3 className="text-xs font-mono uppercase tracking-wider text-gray-500 mb-4">Collection Counts</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {Object.entries(health.collections || {}).map(([key, count]) => (
            <div key={key} className="text-center p-3 bg-gray-50 rounded-md">
              <p className="text-[10px] font-mono uppercase tracking-wider text-gray-400">{key}</p>
              <p className="text-xl font-mono font-bold text-gray-900 mt-1">{count}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
